var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "message",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "message-1",
    d: "M18,0 C18.5522847,1.63861192e-15 19,0.44771525 19,1 L19,11.6666667 C19,12.2189514 18.5522847,12.6666667 18,12.6666667 L15.833,12.666 L15.8333333,15.3360418 C15.8333333,15.8883266 15.3856181,16.3360418 14.8333333,16.3360418 C14.6062618,16.3360418 14.3859513,16.2587611 14.2086383,16.1169106 L10.1427527,12.8642021 C10.0698356,12.8058685 10.0072483,12.7394078 9.95524991,12.6671516 L1,12.6666667 C0.44771525,12.6666667 9.37667865e-16,12.2189514 0,11.6666667 L0,1 C-1.78657678e-16,0.44771525 0.44771525,-9.5692398e-18 1,0 L18,0 Z M3.16666667,2.77083333 L15.8333333,2.77083333 L15.8333333,3.95833333 L3.16666667,3.95833333 L3.16666667,2.77083333 Z M3.16666667,5.54166667 L15.8333333,5.54166667 L15.8333333,6.72916667 L3.16666667,6.72916667 L3.16666667,5.54166667 Z M3.16666667,8.3125 L15.8333333,8.3125 L15.8333333,9.5 L3.16666667,9.5 L3.16666667,8.3125 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "message-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "message-4",
    xlinkHref: "#message-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "message-5",
    fill: "#D8D8D8",
    xlinkHref: "#message-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "message-6",
    mask: "url(#message-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "message-7",
    width: 25.333,
    height: 25.333,
    fill: "#151515",
    transform: "translate(-3.167 -3.167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.212561601f23a6e521523e02b8075d40.svg";
export { ForwardRef as ReactComponent };